import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ToggleMenuGroup } from '@hero/components/molecules/ToggleMenu/style';

export const BannerBadgeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const CustomApprovalNotificationContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

export const PageContent = styled.div`
  display: flex;
  gap: 40px;

  ${ToggleMenuGroup} {
    width: 60%;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 550px;
  min-width: 432px;
`;

export const RotateAnimation = styled(motion.span)``;
